import { Component, Input, OnInit, OnChanges, ViewChild, ElementRef, HostListener, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import {
  AvatarComponentConfig,
  AvatarShape,
  ButtonComponentConfig,
  ButtonSize,
  ButtonType,
  DropdownMenuItem,
  IChatMessage,
  IconType,
  MessageType,
} from '@rappider/rappider-components/utils';
import {
  AiFunctionCallControllerService,
  KeyValuePair,
  KeyValuePairOptionalId,
  Page,
  PageWithRelations,
  Project,
  ProjectChannelMessageSendChannelMessageRequestDto,
  ProjectChannelMessageSendDirectMessageRequestDto,
  ProjectChannelMessageWithRelations,
  ProjectModelWithRelations,
  ProjectWithRelations,
  Category
} from '@rappider/rappider-sdk';
import { Subject, Subscription, interval, of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil, takeWhile } from 'rxjs/operators';
import { FullPaths, PATH_DEFINITIONS } from '@rappider/shared/definitions';
import {
  Navigate,
  RemoveQueryParam,
} from 'libs/shared/src/lib/states/router/router.actions';
import { PageDevelopmentStatus } from '@rappider/admin-dashboard';
import {
  AnalyzeDataSource,
  CreateChannelMessage,
  GetChannelMessagesByTimestamp,
  GetDirectMessagesByTimestamp,
  ResetSenderMessageStatus,
  SendDirectMessage,
} from '../state/ai-assistant.actions';
import { v4 } from 'uuid';
import { KeyValue } from '@angular/common';
import { JoyrideService } from 'ngx-joyride';
import { getCategories } from 'libs/shared/src/lib/states/category/utils/get-categories-selector'

import {
  CardIconTitleDescription,
  EntityConfigInterface,
  EntityItemInterface,
  ListMode,
} from '@rappider/rappider-components';

import { EntityService } from '../services/entity.service';
import { DATA_SOURCE_ENTITY_META_CONFIG } from '../configs/data-source.entity.config';
import { RapiderAiService } from '../services/ai.service';
import {
  MOCK_COMPONENT_DEFINITION,
  MOCK_FOOTBALL_COMPONENT_DEFINITION,
} from './mock.component-definition';
import { environment } from '@environment';
import { SAMPLE_CHAT_QUESTIONS } from '../data/samples';
import { ActivatedRoute, Router } from '@angular/router';

import { BrowserStorageManagementService } from 'libs/shared/src/lib/services/browser-storage-management-service/browser-storage-management.service';

import { ProjectCreateService } from 'libs/project/src/lib/services/project-create.service';
import { RAPIDER_AI_RECEIVER_ID } from '../state/ai-assistant.effects';
import { getProjectModelsWithFields } from '@rappider/shared';
import { StoreKeys, SyncRemoteDataService } from 'libs/shared/src/lib/services/sync/sync-remote-data.service';
import { EntityMetabaseService } from '../services/entity-metabase.service';
import { LoopbackCrudApiService } from '../services/loopback-crud-api.service';

import * as lodash from 'lodash';
import { CollapseLeftSidebar } from 'apps/rappider/src/app/state/app.actions';
import { getChannelAndAnalyzeMessages } from '../selectors/get-channel-and-analyze-messages-selector';
import { isEqual } from 'lodash';
import { DATA_SOURCE_MODAL_GRID_CONFIG } from '../configs/data-source-modal-grid-config';

@Component({
  selector: 'rappider-ai-assistant',
  templateUrl: './ai-assistant.component.html',
  styleUrls: ['./ai-assistant.component.scss'],
})
export class AIAssistantComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isComponentInSidebar = false;

  @Input() features: any[] = [];

  @Input() activeFeature?: {
    id: string;
    title: string;
    description: string;
    name?: string;
    icon: {
      name: string;
      type?: IconType;
    };
    activeEntityRequired?: boolean;
  };

  @ViewChild('container') container!: ElementRef;
  @ViewChild('button', { read: ElementRef }) button!: ElementRef;

  visiblePages: any = [];
  pageActionCardsVisibility = false;
  moreButtonVisible = false;
  activeDataSources = [];
  filteredDataSources;
  actionCardsButtonConfig = {
    type: 'FONT_AWESOME',
    name: 'fa-solid fa-xmark',
    size: ButtonSize.ExtraSmall
  };

  adjustButtons() {
    // page buttons container width
    const containerWidth = this.container?.nativeElement?.offsetWidth;
    // page button width
    const buttonWidth = this.button?.nativeElement?.offsetWidth;
    // calculate the maximum amount of buttons that fits, remove last button for add more button.
    const maxVisibleButtons = Math.floor(containerWidth / (buttonWidth * 1.5)) - 1;
    // calculated number of buttons for display
    this.visiblePages = this.pages?.slice(0, maxVisibleButtons);
    if (maxVisibleButtons >= this.pages?.length) {
      this.moreButtonVisible = false;
      this.closePageActionCardsClick();
    } else {
      this.moreButtonVisible = true;
    }
    this.pageListOnModal = this.pages?.map(page => ({
      ...page,
      iconName: 'fa-regular fa-window',
    }))?.slice(maxVisibleButtons);

  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustButtons();
  }

  /* Displays datasources on the right side */
  displayDataSources = false;

  activeEntityConfig: EntityConfigInterface | undefined;
  activeEntityItem: any;

  entityConfigs: { [key: string]: EntityConfigInterface } = {};
  entityConfigsAsArray = []; // Object.values(this.entityConfigs);

  // Entity configs for project entities
  projectEntityConfigs: { [key: string]: EntityConfigInterface } = {};

  receiverAvatar: AvatarComponentConfig = {
    shape: AvatarShape.Square,
    imageUrl: '/assets/img/logo/rappider-logo.png',
  };
  senderAvatar: AvatarComponentConfig = {
    shape: AvatarShape.Square,
    icon: {
      name: 'fa-regular fa-user',
      type: IconType.FontAwesome,
    },
    colorSettings: {
      backgroundColor: 'var(--section-background-color)',
    },
  };
  displayedMessages: IChatMessage[] = [];
  activeProject?: Project | ProjectWithRelations;
  projects: ProjectWithRelations[] | undefined;
  projectModels: ProjectModelWithRelations[] | undefined;
  subscriptions: Subscription[] = [];
  pages!: Page[] | PageWithRelations[] | null;
  isTyping = false;
  isMessagesLoaded = false;
  quickAnswerOptions?: KeyValue<string, string>[];

  splitterLeftContainerMinSize = 2000; // used for the min size
  splitterRightContainerSize = 740;

  readonly maxRightSplitterSize = 1000; // The target size when expanding
  private animationInterval: any;      // To hold the interval ID for clearing
  private readonly animationDuration = 250; // Animation speed in ms (smooth but not slow)
  readonly readableChatSize = 800; // Minimum size to read chat comfortably


  /* entity selector visibility */
  entitySelectorVisibility = false;

  // /* client data */
  // clientData__participants: Participant[] | null = null;
  // clientData__tours: Tour[] | null = null;
  // clientData__tourParticipants: TourParticipant[] | null = null;

  entityData: Record<string, any> = {};
  activeEntityName = 'Participant';
  parentEntityName = 'Tour';
  parentEntityDataListSelector = 'tours';
  parentEntityDataActiveItemSelector = 'activeTour';

  activeEntityGetFiltersForUpdateAction: any[] = [];
  actionsToDispatch: any[] = [];
  // a planning id is used to track the AI planning function call
  activeAiPlanningId: string | undefined = undefined;
  activeAiPlannedOperations: any[] = [];

  allChannelMessages: Record<string, ProjectChannelMessageWithRelations[]> = {};
  channelMessages: ProjectChannelMessageWithRelations[] = [];
  displayedChannelMessages: ProjectChannelMessageWithRelations[] = [];
  /* Displays a button to go back to previous messages on top of the user's message */
  previousMessageButtonVisible = true;
  previousMessage: ProjectChannelMessageWithRelations | undefined;
  /* Displays a button to go forward to next messages on top of the user's message */
  nextMessageButtonVisible = true;
  nextMessage: ProjectChannelMessageWithRelations | undefined;
  /* We will only display the latest user message and its follow-ups
   * If the user goes back to a previous question, we will show the relevant messages.
   * And save the previous messages that are in display on this variable.
   */
  displaySpecificMessageIds: string[] | undefined;
  /* Reference ID for the message to go back to, when we need to load previous messages asynchronously */
  gotoPreviousMessageReferenceId: string | undefined;
  joyrideStepOne = {
    joyrideStep: 'first',
    title: 'Ask Your Question Here',
    text: 'You can type your question in this section to get assistance or clarification. This is your primary space to communicate with us.'
  };
  joyrideStepTwo = {
    joyrideStep: 'second',
    title: 'Choose Your Agent Here',
    text: 'Select your agent from this section. Each agent has a different symbolic meaning, which adds depth to your experience. However, we pre-select the knowledge agent for you automatically to simplify the process.'
  };
  isTourDone = '';
  tour = '';

  /* local channelId */
  channelId = 'private'; // default to private chat

  // parentEntityCardListConfig: any = ENTITY_CONFIG['Tour'].config?.listWrapperConfig?.cardListConfig ?? {};
  // no parent entity, use detail pages for related entities

  aiCallInProgress = false;

  // Demo project flag, display a demo warning for the demo project
  isDemoProject: boolean | undefined;
  /* Flag to indicate if a sample chat question has been asked */
  sampleChatQuestionAsked = false;

  // Default AI sender ID, can be replaced with actual AI sender ID if available
  aiSenderId = '00000000-0000-0000-0000-000000000001';

  /* Actions items to show ver the chat input */
  actionCardItems: CardIconTitleDescription[] = [

    // {
    //   id: 'add-datasource',
    //   title: 'Recommend Follow-up Appointments',
    //   key: 'add-datasource',
    //   iconName: 'fa fa-solid fa-calendar-check',
    //   description: 'Recommend follow-up appointments based on patient history',
    // }
  ];

  dataSourcesGridConfig = DATA_SOURCE_MODAL_GRID_CONFIG;
  categories: Category[] = [];

  pageListOnModal = [];
  private pollingRAG$ = new Subject<void>();

  constructor(
    private store: Store<any>,
    private aiFunctionCallControllerService: AiFunctionCallControllerService,
    private entityService: EntityService,
    private entityMetabaseService: EntityMetabaseService,
    private rapiderAiService: RapiderAiService,
    private router: Router,
    private projectCreateService: ProjectCreateService,
    private browserStorageManagementService: BrowserStorageManagementService,
    private activatedRoute: ActivatedRoute,
    private readonly joyrideService: JoyrideService,
    private loopbackCrudApiService: LoopbackCrudApiService,
    private syncRemoteDataService: SyncRemoteDataService
  ) {
    this.entityConfigs = {
      DataSource: this.entityService.generateEntityConfig(
        DATA_SOURCE_ENTITY_META_CONFIG
      ),
      // AiFunctionCall: this.entityService.generateEntityConfig(AI_FUNCTION_CALL_ENTITY_META_CONFIG)
    };

    this.activeEntityConfig = this.entityConfigs['DataSource'];
  }

  ngOnInit(): void {
    this.subscriptions = [
      this.subscribeToRouterParams(),
      this.subscribeToActiveProject(),
      this.subscribeToProjects(), // get all projects in order to calculate the next project name when create a new project clicked
      this.subscribeToPages(), // get all pages in order to show the page navigation buttons if above the chat input
      this.subscribeToAIAssistantTypingStatus(),
      this.subscribeToChannelMessages(),
      this.subscribeToServiceActivatedRouteQueryParams(),
      this.subscribeToProjectModels(), // get all project models to calculate project entity configs to show entity data in chat messages
      this.subscribeToLeftSideBarCollapseStatus(),
      this.subscribeToDataSourcesAndCategories(),
      this.subscribeToSenderMessageStatus()
    ];
    this.initWatcher();
    this.tour = this.browserStorageManagementService.getLocalStorageItem('tour');
    interval(5000).pipe(
      takeUntil(this.pollingRAG$)
    ).subscribe(() => {
      this.syncRemoteDataService.syncRemoteDataItemWithKey(this.activeProject?.id, StoreKeys.AnalyzeMessages);
    });
  }


  ngOnChanges(): void {
    // This will be triggered when inputs change.
    // If channel changes are not input-driven, this might not be needed.
    // Kept for now, but can be removed if router subscription handles all cases.
    this.getChannelMessages();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.pollingRAG$.next();
    this.pollingRAG$.complete();
  }

  onIsChatInputRendered(isRendered) {
    if (isRendered && this.browserStorageManagementService.getLocalStorageItem('tour') !== 'nineth' && this.browserStorageManagementService.getLocalStorageItem('tour') !== 'third') {
      // this.showSteps();
    }
  }

  updateEntityData(key: string, data: any) {
    this.entityData = {
      ...this.entityData,
      [key]: data,
    };
  }

  /**
   * BUG FIX: Simplified and clarified the logic for getting the channel ID.
   * It now returns a string ('private', 'general', or a UUID) which simplifies
   * the logic in other methods.
   */
  getChannelId(): string {
    const channelId = this.activatedRoute.snapshot.params['channelId'];
    // If channelId is falsy (e.g., undefined) or 'private', we treat it as 'private'.
    this.channelId = !channelId || channelId === 'private' ? 'private' : channelId;
    return this.channelId;
  }

  // get the channelID and strip any qparams after `?`
  getChannelIdWithoutQueryParams(): string {
    const channelId = this.activatedRoute.snapshot.params['channelId'];
    return channelId ? channelId.split('?')[0] : 'private';
  }

  subscribeToServiceActivatedRouteQueryParams() {
    return this.activatedRoute.queryParams.subscribe(q => {
      if (this.browserStorageManagementService.getLocalStorageItem('tour') === 'done') {
        this.isTourDone = 'true';
        this.browserStorageManagementService.setLocalStorageItem('tour', 'nineth');
      }
    });
  }

  subscribeToRouterParams() {
    return this.activatedRoute.params.subscribe((params) => {
      // This ensures that every time the route changes,
      // we fetch the new channel's messages.
      this.getChannelMessages();
    });
  }

  subscribeToActiveProject() {
    return this.store
      .select((state) => state.activeProject.data)
      .subscribe((activeProject) => {
        const previousProjectId = this.activeProject?.id;
        this.activeProject = activeProject;
        this.isDemoProject = environment.demoProjectIds.includes(activeProject?.id);
        if (this.activeProject?.id && previousProjectId !== this.activeProject.id) {
          this.getAiFeatureFunctions();
          this.getPrivateAndDefaultChannelMessages();
        }
        this.syncRemoteDataService.syncRemoteDataItemWithKey(activeProject?.id, StoreKeys.AnalyzeMessages);
      });
  }

  subscribeToProjects() {
    return this.store
      .select((state) => state.project.data)
      .subscribe((projects: ProjectWithRelations[]) => {
        this.projects = projects;
      });
  }

  subscribeToPages() {
    return this.store.select(state => state.page?.data).subscribe(pages => {
      this.pages = pages?.length ? pages.filter((page: PageWithRelations) => !!page.isActive) : [];
      this.pageListOnModal = pages?.map(page => ({
        id: page?.id,
        title: page?.title,
        key: page?.name,
        iconName: 'fa-file fa-regular',
        description: page?.description,
      }))
      this.adjustButtons();
    });
  }

  subscribeToProjectModels() {
    return this.store.select(<any>getProjectModelsWithFields).subscribe(projectModels => {
      this.projectModels = projectModels;
      this.generateEntityConfigs();
    });
  }

  subscribeToLeftSideBarCollapseStatus() {
    return this.store.select(state => state.app.leftSidebarCollapsed).subscribe(() => {
      setTimeout(() => { this.adjustButtons(); }, 0);
    });
  }

  subscribeToDataSourcesAndCategories() {
    return this.store.select(
      createSelector(
        state => state['dataSource'].data,
        getCategories,
        (datasources, categories) => {
          return {
            datasources: datasources,
            categories: categories
          }
        }
      )
    ).subscribe(dataSourcesAndCategories => {
      this.activeDataSources = dataSourcesAndCategories?.datasources?.filter(d => d?.isDeletable !== false && d?.isUpdatable !== false)?.map(datasource => {
        if (datasource?.syncStatus === 'ai-ingestion-vector-generation-completed' || datasource?.hasEverBeenIngested === true) {
          return {
            ...datasource,
            selected: true,
            status: this.getText(datasource?.syncStatus),
            ingestionStatus: datasource?.syncStatus === 'ai-ingestion-vector-generation-completed' ? 'All File Ingested' : 'Partially Ingested',
            category: dataSourcesAndCategories?.categories?.find(category => category.id === datasource.categoryId)?.title || ''
          }
        } else {
          return {
            ...datasource,
            selected: false,
            status: this.getText(datasource?.syncStatus),
            disabled: true,
            ingestionStatus: 'Not Ingested',
            category: dataSourcesAndCategories?.categories?.find(category => category.id === datasource.categoryId)?.title || ''
          }
        }
      })
      this.categories = dataSourcesAndCategories?.categories;
      if (this.categories?.length) {
        this.dataSourcesGridConfig = {
          ...this.dataSourcesGridConfig, filterDataByFields: dataSourcesAndCategories?.categories?.map(category => ({
            title: category?.title || category?.name,
            fieldName: category?.id || category?.id
          }))
        }
      }
    });
  }

  getText(input: string): string {
    return this.syncStatusConfig[input] || '';
  }

  syncStatusConfig: { [key: string]: any } = {
    'not-started': 'Not Started',
    'file-upload-completed': 'File Upload Completed',
    'ready-for-ai-ingestion': 'Ready For AI Ingestion',
    'ai-ingestion-in-progress': 'AI Ingestion Is In Progress',
    'data-sync-completed': 'Data Sync Completed',
    'file-storage-ingestion-in-progress': 'File Storage Ingestion Is In Progress',
    'file-storage-updated': 'File Storage Updated',
    'file-ingestion-in-progress': 'File Ingestion Is In Progress',
    'file-storage-completed': 'File Storage Completed – Preparing for AI Ingestion',
    'ai-ingestion-chunk-generation-in-progress': 'AI Ingestion Is In Progress',
    'ai-ingestion-chunk-generation-completed': 'AI Ingestion Is In Progress',
    'ai-ingestion-vector-generation-in-progress': 'AI Ingestion Is In Progress',
    'ai-ingestion-completed': 'AI Ingestion Completed',
    'ai-ingestion-vector-generation-completed': 'AI Ingestion Completed',
    'file-ingestion-failed': 'File Ingestion Failed',
    'failed': 'Failed',
    'ai-ingestion-token-limit-failure': 'AI Token Limit Exceeded',
    'file-storage-failed': 'File Storage Failed',
    'file-storage-ingestion-failed': 'AI Ingestion Failed',
    'ai-ingestion-chunk-generation-failure': 'AI Ingestion Failed',
    'ai-ingestion-vector-generation-failure': 'AI Ingestion Failed',
    'file-physically-missing': 'File Missing',
    'ai-ingestion-chunk-generation-failed': 'Ai Ingestion Failed',
    'ai-ingestion-vector-generation-failed': 'Ai Ingestion Failed',
    'ai-ingestion-token-limit-failed': 'AI Token Limit Failed',
    'project-file-missing': 'Project File Missing',
    'ai-ingestion-failed-for-scanned-pdf': 'AI Ingestion Failed For Scanned PDF',
    'ai-ingestion-partially-failed-for-scanned-pdf': 'AI Ingestion Partially Failed For Scanned PDF'
  };

  generateEntityConfigs() {
    this.projectModels?.forEach((projectModel: ProjectModelWithRelations) => {
      const entityMetaConfig = this.entityMetabaseService.generateConfig(projectModel);
      entityMetaConfig.dataFetchedFrom = 'loopback-root-entity-api'; // Default value
      this.projectEntityConfigs[projectModel.dataTableName] = this.entityService.generateEntityConfig(entityMetaConfig);
      this.projectEntityConfigs[projectModel.dataTableName].config.listMode = ListMode.Grid; // Default to grid view for project models
      if (this.projectEntityConfigs[projectModel.dataTableName].config.listGridConfig) {
        this.projectEntityConfigs[projectModel.dataTableName].config.listGridConfig.hideToolbar = true; // Hide toolbar for grids of project models
      }
    });
    // this.entityConfigsAsArray = Object.values(this.entityConfigs);
  }

  subscribeToChannelMessages() {
    return this.store
      .select(getChannelAndAnalyzeMessages)
      .subscribe((allChannelMessages) => {
        if (allChannelMessages) {
          if (!isEqual(this.allChannelMessages, allChannelMessages)) {
            this.isMessagesLoaded = !!allChannelMessages;
            this.allChannelMessages = allChannelMessages;
            this.processChannelMessages();
          }
        }
      });
  }

  /**
   * This method clears the `channelMessages` array before
   * populating it with new messages. This prevents showing messages from a previous channel.
   */
  processChannelMessages() {
    const channelId = this.getChannelId();
    // Always clear the current messages to prevent showing stale data from another channel
    this.channelMessages = [];
    this.displayedChannelMessages = [];

    if (this.allChannelMessages && this.allChannelMessages[channelId]?.length) {
      this.aiCallInProgress = false;
      const channelMessages = this.allChannelMessages[channelId].map(
        (message: ProjectChannelMessageWithRelations) => {
          const hydratedMessage = { ...message };

          if (SAMPLE_CHAT_QUESTIONS?.includes(hydratedMessage?.message)) {
            this.sampleChatQuestionAsked = true;
          }
          if (hydratedMessage?.message === '__EMPTY_MESSAGE__') {
            hydratedMessage.message = '';
          }
          if (message?.config?.displayWithComponent?.componentDefinitionId) {
            if (
              message?.config?.displayWithComponent?.componentDefinitionId ===
              MOCK_COMPONENT_DEFINITION?.id
            ) {
              hydratedMessage.displayWithComponent = {
                componentDefinition: MOCK_COMPONENT_DEFINITION,
              };
            } else if (
              message?.config?.displayWithComponent?.componentDefinitionId ===
              MOCK_FOOTBALL_COMPONENT_DEFINITION?.id
            ) {
              hydratedMessage.displayWithComponent = {
                componentDefinition: MOCK_FOOTBALL_COMPONENT_DEFINITION,
              };
            }
          }
          return hydratedMessage;
        }
      );

      this.channelMessages = channelMessages;

      // reset navigation state
      this.resetMessageNavigation();

      this.setDisplayedChannelMessages();

    }
  }
  // resets the message navigation
  resetMessageNavigation() {
    this.gotoPreviousMessageReferenceId = undefined;
    this.displaySpecificMessageIds = undefined;
  }

  setDisplayedChannelMessages() {
    // --- Step 1: Determine which message IDs should be displayed ---
    // If we are navigating from a button click, this block will run.
    if (this.gotoPreviousMessageReferenceId) {
      const referenceIndex = this.channelMessages.findIndex(
        m => m.id === this.gotoPreviousMessageReferenceId
      );

      if (referenceIndex !== -1) {
        // Find the index of the user message that starts the *previous* conversation turn.
        const targetUserMessageIndex = this.findPreviousUserMessageIndex(referenceIndex);

        if (targetUserMessageIndex !== -1) {
          // A conversation turn includes the user message and all AI replies that follow.
          // It ends just before the next user message (which is at `referenceIndex`).
          this.displaySpecificMessageIds = this.channelMessages
            .slice(targetUserMessageIndex, referenceIndex)
            .map((message) => message.id);
        } else {
          // Handle the case where there are no more previous messages.
          // You may want to disable the "previous" button here.
        }
      }
      // Reset the trigger so this logic doesn't run again unintentionally.
      this.gotoPreviousMessageReferenceId = undefined;
    }


    // --- Step 2: Update displayed messages and navigation state ---
    // This logic now runs immediately after the block above, ensuring state is always in sync.
    // NOTE: The `else` was removed from `else if` to allow this to run every time.
    if (this.displaySpecificMessageIds?.length) {
      // Filter the main list to get the messages we want to show on screen.
      this.displayedChannelMessages = this.channelMessages.filter(
        m => this.displaySpecificMessageIds.includes(m.id)
      );

      // Find the position of the currently displayed messages in the full list.
      const firstDisplayedMessageIndex = this.channelMessages.findIndex(
        (message) => message.id === this.displaySpecificMessageIds[0]
      );
      const lastDisplayedMessageIndex = this.channelMessages.findIndex(
        (message) => message.id === this.displaySpecificMessageIds[this.displaySpecificMessageIds.length - 1]
      );

      // **Crucially, update the navigation properties based on the NEW display state.**
      const previousUserMessageIndex = this.findPreviousUserMessageIndex(firstDisplayedMessageIndex);
      this.previousMessage = this.channelMessages[previousUserMessageIndex]; // Safely becomes undefined if not found

      const nextUserMessageIndex = this.findNextUserMessageIndex(lastDisplayedMessageIndex);
      this.nextMessage = this.channelMessages[nextUserMessageIndex]; // Safely becomes undefined if not found

    } else {
      // This is the default case for when the chat first loads.
      // It displays the most recent user message and its replies.
      const lastUserMessageIndex = this.findPreviousUserMessageIndex(this.channelMessages.length);
      if (lastUserMessageIndex !== -1) {
        this.displayedChannelMessages = this.channelMessages.slice(lastUserMessageIndex);
        // Sync the specific IDs with what is being displayed.
        this.displaySpecificMessageIds = this.displayedChannelMessages.map(m => m.id);

        const previousUserMessageIndex = this.findPreviousUserMessageIndex(lastUserMessageIndex);
        this.previousMessage = this.channelMessages[previousUserMessageIndex];
        this.nextMessage = undefined; // At the end, so no "next"

        // if there is an UI to show display it
        if (this.displayedChannelMessages?.length && this.displayedChannelMessages[this.displayedChannelMessages?.length - 1]) {
          // Show the UI for the displayed messages
          const lastAiMessage = this.displayedChannelMessages[this.displayedChannelMessages.length - 1];
          if (lastAiMessage?.data?.showUI) {
            // Display the UI content
            console.log('Navigating to UI:', lastAiMessage.data.showUI);
            this.router.navigateByUrl(this.router.parseUrl(lastAiMessage.data.showUI)); // or simply navigateByUrl(url)
            // this.store.dispatch(new Navigate({ url: lastAiMessage.data.showUI }));
          }
        }
      }
    }
  }

  /* Finds previous user message index */
  findPreviousUserMessageIndex(currentIndex: number): number {
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (this.channelMessages[i].senderId !== this.aiSenderId) {
        return i;
      }
    }
    return -1;
  }

  /* Finds next user message index */
  findNextUserMessageIndex(currentIndex: number): number {
    for (let i = currentIndex + 1; i < this.channelMessages.length; i++) {
      if (this.channelMessages[i].senderId !== this.aiSenderId) {
        return i;
      }
    }
    return -1;
  }

  subscribeToAIAssistantTypingStatus() {
    return this.store
      .select((state) => state.aiAssistant.isAssistantTyping)
      .subscribe((isAssistantTyping) => (this.isTyping = isAssistantTyping));
  }

  /**
   * This method clears the `channelMessages` array before
   * populating it with new messages. This prevents showing messages from a previous channel.
   */
  getChannelMessages(timestamp?: string) {
    const channelId = this.getChannelId();

    if (channelId === 'private') {
      // For private chats, get direct messages.
      this.store.dispatch(
        GetDirectMessagesByTimestamp({
          payload: { timestamp, receiverId: RAPIDER_AI_RECEIVER_ID },
        })
      );
    } else {
      // For public channels, get channel messages.
      // If channelId is 'general', API fetches the default channel's messages.
      this.store.dispatch(
        GetChannelMessagesByTimestamp({
          payload: {
            timestamp,
            channelId: channelId === 'general' ? undefined : channelId,
          },
        })
      );
    }
    // Immediately process any messages already in the state.
    // This will clear the view until new messages for the current channel arrive.
    this.processChannelMessages();
  }

  getPrivateAndDefaultChannelMessages() {
    this.store.dispatch(
      GetDirectMessagesByTimestamp({
        payload: {
          timestamp: new Date().toISOString(),
          receiverId: RAPIDER_AI_RECEIVER_ID,
        },
      })
    );
    this.store.dispatch(
      GetChannelMessagesByTimestamp({
        payload: { timestamp: new Date().toISOString(), channelId: undefined },
      })
    );
  }

  // onScrolledToTop(timestamp: string) {
  //   this.getChannelMessages(timestamp);
  // }

  onGoToPreviousMessages(messageId: string) {
    if (messageId) {
      const messageIndex = this.channelMessages.findIndex(
        (message) => message.id === messageId
      );
      /* If there are two previous messages, display them */
      if (messageIndex >= 2) {
        let previousUserMessageIndex = messageIndex - 1;
        /* Find the previous message from the user */
        while (previousUserMessageIndex > 0 && this.channelMessages[previousUserMessageIndex].senderId === this.aiSenderId) {
          previousUserMessageIndex--;
        }

        this.displaySpecificMessageIds = this.channelMessages
          .slice(previousUserMessageIndex, messageIndex)
          .map((message) => message.id);
      } else {
        this.previousMessageButtonVisible = false;
        // TODO: load previous messages
        // this.gotoPreviousMessageReferenceId = messageId;
        // this.getChannelMessages(this.channelMessages[0]?.createdDate);
      }
      this.setDisplayedChannelMessages();
    }
  }

  onGoToNextMessages(messageId: string) {
    if (messageId && this.displaySpecificMessageIds?.length) {
      const lastDisplayedMessageIndex = this.channelMessages.findIndex(
        (message) => message.id === this.displaySpecificMessageIds[this.displaySpecificMessageIds.length - 1]
      );
      /* find the next user message */
      if (lastDisplayedMessageIndex < this.channelMessages.length - 2) {
        let nextUserMessageIndex = lastDisplayedMessageIndex + 1;
        /* Find the next message from the user */
        while (nextUserMessageIndex <= this.channelMessages.length - 1 && this.channelMessages[nextUserMessageIndex].senderId === this.aiSenderId) {
          nextUserMessageIndex++;
        }
        let secondNextUserMessageIndex = nextUserMessageIndex + 1;
        /* Find the second next message from the user */
        while (secondNextUserMessageIndex <= this.channelMessages.length - 1 && this.channelMessages[secondNextUserMessageIndex].senderId === this.aiSenderId) {
          secondNextUserMessageIndex++;
        }

        if (secondNextUserMessageIndex > nextUserMessageIndex && secondNextUserMessageIndex < this.channelMessages.length) {
          this.previousMessageButtonVisible = true;
          this.displaySpecificMessageIds = this.channelMessages
            .slice(nextUserMessageIndex, secondNextUserMessageIndex)
            .map((message) => message.id);
        } else {
          this.displaySpecificMessageIds = undefined;
        }

      } else {
        this.displaySpecificMessageIds = undefined;
      }
      this.setDisplayedChannelMessages();
    }
  }

  sendMessageToRapider(
    message: string,
    files?: File[],
    data?: null | { [key: string]: any },
    config?: null | { [key: string]: any },
    metadata?: Array<KeyValuePairOptionalId>
  ) {
    if (message?.trim() && this.activeFeature?.name === 'RAGSearch') {
      this.store.dispatch(AnalyzeDataSource({ payload: { dataSourceIds: (this.filteredDataSources || (this.activeDataSources ?? [])?.filter(activeDataSource => activeDataSource.selected === true))?.map(datasource => datasource.id), message } }));
    }
    // on message sent, execute the AI Planning function call
    else if (message?.trim() && this.activeFeature?.id) {
      this.addToMessages(message, data, config, metadata);
      this.aiCallInProgress = true;
    }
  }

  subscribeToSenderMessageStatus() {
    return this.store.select((state) => state.aiAssistant.isSenderMessageSendSuccessfully).subscribe((isSenderMessageSendSuccessfully) => {
      if (isSenderMessageSendSuccessfully) {
        this.aiCallInProgress = true;
        this.store.dispatch(ResetSenderMessageStatus());
      }
    });
  }

  onFeatureSelected(feature: any) {
    if (feature?.id) {
      this.activeFeature = feature;
    }
  }

  onDisplayDataSourcesButtonClicked(event: string) {
    this.displayDataSources = !this.displayDataSources;
  }

  addToMessages(
    message: any,
    data?: null | { [key: string]: any },
    config?: null | { [key: string]: any },
    metadata?: Array<KeyValuePairOptionalId>
  ) {
    if (message?.trim()) {
      const receiverId = RAPIDER_AI_RECEIVER_ID; // '00000000-0000-0000-0000-000000000001'; // default receiver id for Rapider AI
      const messageObj:
        | ProjectChannelMessageSendChannelMessageRequestDto
        | ProjectChannelMessageSendDirectMessageRequestDto
        | any = {
        message: message,
        aiFunctionId: this.activeFeature?.id,
        status: 'new',
        type: 'message',
        metadata: metadata ?? [],
      };

      if (data) {
        messageObj.data = data;
      }

      if (config) {
        messageObj.config = config;
      }

      if (metadata) {
        messageObj.metadata = metadata;
      }

      /* CUSTOM MOCK COMPONENT DEFINITION */
      if (this.activeFeature?.id === '00b44b3c-80ac-4b3a-b982-273e455272f6') {
        messageObj.displayWithComponent = {
          componentDefinition: MOCK_COMPONENT_DEFINITION,
        };
      }

      /* MOCK_FOOTBALL_COMPONENT_DEFINITION*/
      if (this.activeFeature?.id === '326fa351-6270-4670-9b6d-d8eb87b9879a') {
        messageObj.displayWithComponent = {
          componentDefinition: MOCK_FOOTBALL_COMPONENT_DEFINITION,
        };
      }

      /* MOCK_FOOTBALL_COMPONENT_DEFINITION*/
      if (this.activeFeature?.id === '326fa351-6270-4670-9b6d-d8eb87b9879a') {
        messageObj.displayWithMarkdown = {
          displayField: 'message',
        };
      }

      const channelId = this.getChannelId();
      if (channelId === 'private') {
        // if there is no channelId, we assume it's a private conversation with Rapider AI
        const directMessage: ProjectChannelMessageSendDirectMessageRequestDto = {
          ...messageObj,
          type: 'direct-message',
          receiverId: RAPIDER_AI_RECEIVER_ID,
        };

        this.store.dispatch(
          SendDirectMessage({
            payload: {
              message: directMessage,
              receiverId: RAPIDER_AI_RECEIVER_ID,
              tempId: v4(), // Generate a temporary ID for optimistic updates
            },
          })
        );
      } else {
        // if there is a channelId, we send the message to that channel
        const channelMessage: ProjectChannelMessageSendChannelMessageRequestDto = {
          ...messageObj,
          channelId: channelId,
        };

        this.store.dispatch(
          CreateChannelMessage({ payload: { message: channelMessage } })
        );
      }
    }
  }

  onChangeEntityButtonClicked() {
    this.entitySelectorVisibility = !this.entitySelectorVisibility;
  }

  buildQuickAnswerOptions() {
    if (this.displayedMessages?.length) {
      const quickAnswerMetadata = this.displayedMessages[
        this.displayedMessages.length - 1
      ]?.metadata?.find(
        (metadata: KeyValuePair) => metadata.key === 'message-options'
      );
      if (quickAnswerMetadata) {
        this.quickAnswerOptions = quickAnswerMetadata.value;
      } else {
        this.quickAnswerOptions = [];
      }
    }
  }

  buildNavigateButtonByMessage(
    message: any
  ): ButtonComponentConfig | undefined {
    const button: ButtonComponentConfig = {
      type: ButtonType.Default,
      size: ButtonSize.ExtraSmall,
    };
    const pageMetadata = message?.metadata?.find(
      (metadata: any) => metadata.key === 'page-created'
    );
    const modelMetadata = message?.metadata?.find(
      (metadata: any) => metadata.key === 'model'
    );
    const themeMetadata = message?.metadata?.find(
      (metadata: any) => metadata.key === 'theme'
    );
    if (pageMetadata) {
      button.text = 'Go to page';
      button.key = `${PATH_DEFINITIONS.CONTENT_EDITOR.CONTENT_EDITOR_PATH}/${pageMetadata.value}`;
      return button;
    } else if (modelMetadata) {
      button.text = 'Go to model';
      button.key = `${PATH_DEFINITIONS.DATABASE_DIAGRAM_EDITOR.DATABASE_DIAGRAM_EDITOR_PATH}`;
      return button;
    } else if (themeMetadata) {
      button.text = 'Go to theme';
      button.key = `${PATH_DEFINITIONS.PROJECTS.PROJECT_THEME}/${themeMetadata.value}`;
      return button;
    } else {
      return undefined;
    }
  }

  onMessageButtonClick(message: any) {
    if (message?.additionalButton?.key) {
      this.store.dispatch(new Navigate({ url: message.additionalButton.key }));
    }
  }

  controlPage() {
    this.displayedMessages.forEach((message) => {
      const pageMetadata = message?.metadata?.find(
        (metadata: any) => metadata.key === 'page-created'
      );
      if (pageMetadata && message?.additionalButton) {
        const page = this.pages?.find((p: Page) => p.id === pageMetadata?.value);
        message.additionalButton.tooltipText =
          page?.developmentStatus === PageDevelopmentStatus.InReview
            ? 'This page is in review.'
            : undefined;
        message.additionalButton.disabled =
          page?.developmentStatus === PageDevelopmentStatus.InReview;
      }
    });
  }

  onFullScreenButtonClick() {
    this.store.dispatch(new RemoveQueryParam({ key: 'activeRightSidebarTab' }));
    this.store.dispatch(new Navigate({ url: PATH_DEFINITIONS.AI.ASSISTANT }));
  }

  onQuickAnswerButtonClick(option: string) {
    this.sendMessageToRapider(option);
  }

  onSplitDragEnds(event: any) {
    console.log('splitter drag ends', event);
    this.splitterRightContainerSize = event.sizes[1];
    this.collapseLeftSidebarIfChatAreaIsNotReadable();
  }

  onItemSelectedFromActiveItemSelector(itemId: string) {
    console.log('Item selected from active item selector:', itemId);
    this.activeEntityItem = this.entityData[
      this.parentEntityDataListSelector
    ]?.find((entity: any) => entity.id === itemId);
    this.entitySelectorVisibility = false;
  }

  getAiFeatureFunctions() {
    this.rapiderAiService
      .getAiFeatureFunctions()
      .subscribe((aiFeatures: any[] | null | undefined) => {
        if (aiFeatures?.length) {
          this.features = [{ name: 'RAGSearch', title: 'RAG Search', description: 'RAG Search', id: 'ragsearch' }, ...aiFeatures].map((feature: any) => ({
            id: feature?.id,
            title: feature.title,
            name: feature?.name,
            description: feature.description,
            icon: {
              name: feature.icon?.name || 'fa-regular fa-sparkles',
              type: feature.icon?.type || IconType.FontAwesome,
            },
          }));
          if (this.features?.length) {
            // Set the first feature as active by default
            this.activeFeature =
              this.features.find((f) => f.title === 'Health Agent') ||
              this.features[0];
          }
        } else {
          console.error('No AI feature functions found');
        }
      });
  }

  sendMessageToAiFeature(aiFeatureId: string, message: string): void {
    const planningId = v4();

    if (message) {
      const params = {
        id: aiFeatureId,
        body: {
          functionPrompt: message,
        },
      };
      this.aiCallInProgress = true;

      this.aiFunctionCallControllerService
        .executeFunctionToolsCall$Json(params)
        .pipe(
          mergeMap((response: any) => {
            console.log('AI Function Planning Call executed:', response);
            this.handleAiFeatureResponses(aiFeatureId, planningId, response);
            return of(response);
          }),
          catchError((error: any) => {
            console.error('Error executing Planning AI function call:', error);
            return of(error);
          })
        )
        .subscribe(
          () => {
            this.aiCallInProgress = false;
          },
          () => {
            this.aiCallInProgress = false;
          }
        );
    }
  }

  handleAiFeatureResponses(
    aiFeatureId: string,
    planningId: string,
    response: any
  ) {
    const aiMessage: any = {
      keyForUI: v4(),
      content:
        response?.message ||
        response?.answer ||
        '__EMPTY_MESSAGE__',
      data: response,
      type: MessageType.AI,
      timestamp: new Date().toISOString(),
    };

    /* CUSTOM MOCK COMPONENT DEFINITION */
    if (this.activeFeature?.id === '00b44b3c-80ac-4b3a-b982-273e455272f6') {
      aiMessage.displayWithComponent = {
        componentDefinition: MOCK_COMPONENT_DEFINITION,
      };
      aiMessage.config = {
        displayWithComponent: {
          componentDefinitionId: MOCK_COMPONENT_DEFINITION?.id,
        },
      };
    }

    /* MOCK_FOOTBALL_COMPONENT_DEFINITION*/
    if (this.activeFeature?.id === '326fa351-6270-4670-9b6d-d8eb87b9879a') {
      aiMessage.displayWithComponent = {
        componentDefinition: MOCK_FOOTBALL_COMPONENT_DEFINITION,
      };
      aiMessage.config = {
        displayWithComponent: {
          componentDefinitionId: MOCK_FOOTBALL_COMPONENT_DEFINITION?.id,
        },
      };
    }
  }

  handleAiGetOperation(response: any, planningId: string) {
    console.log('handleAiGetOperation:', response);

    // reset the actions to dispatch
    this.actionsToDispatch = [];

    let getActions = [];
    for (const actionGroup of response) {
      if (actionGroup.get && actionGroup.get.length > 0) {
        getActions = actionGroup.get as any[]; // action payload array for get actions, we expect only one get action
      }
    }

    // get the data to update first
    if (getActions?.length) {
      getActions.forEach((getAction: any) => {
        // type is like '[Participant] Get'; parse entity name inside the []
        const entityName: string = getAction?.type?.match(/\[(.*?)\]/)?.[1];

        let actionType = `[${entityName.toUpperCase()}] Get${entityName}s`;

        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.getEntityItemsActionType) {
          actionType = entityConfig?.config?.getEntityItemsActionType;
        }

        this.store.dispatch({
          ...getAction,
          type: actionType,
          payload: {
            ...getAction.payload,
            filterId: planningId, // we pass the planning id to match to fetched data from the filter id
          },
        });
      });
    }
  }

  handleAiCreateOperation(response: any, planningId: string) {
    console.log('handleAiCreateOperation:', response);

    // reset the actions to dispatch
    this.actionsToDispatch = [];

    let getActions = [];
    let createActions = [];
    for (const actionGroup of response) {
      if (actionGroup.get && actionGroup.get.length > 0) {
        getActions = actionGroup.get as any[]; // action payload array for get actions, we expect only one get action
      }
      if (actionGroup.create && actionGroup.create.length > 0) {
        createActions = actionGroup.create as any[]; // action payload array for update actions
      }
    }

    if (createActions?.length) {
      createActions.forEach((createAction: any) => {
        // type is like '[Participant] Get'; parse entity name inside the []
        const entityName: string = createAction?.type?.match(/\[(.*?)\]/)?.[1];

        let actionType = `[${entityName.toUpperCase()}] Create${entityName}`;

        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.createEntityActionType) {
          actionType = entityConfig?.config?.createEntityActionType;
        }

        this.store.dispatch({
          ...createAction,
          type: actionType,
        });
      });
    }

    // get the data to update first
    if (getActions?.length) {
      getActions.forEach((getAction: any) => {
        // type is like '[Participant] Get'; parse entity name inside the []
        const entityName: string = getAction?.type?.match(/\[(.*?)\]/)?.[1];

        let actionType = `[${entityName.toUpperCase()}] Get${entityName}s`;

        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.getEntityItemsActionType) {
          actionType = entityConfig?.config?.getEntityItemsActionType;
        }

        setTimeout(() => {
          this.store.dispatch({
            ...getAction,
            type: actionType,
            payload: {
              ...getAction.payload,
              filterId: planningId, // we pass the planning id to match to fetched data from the filter id
            },
          });
        }, 1000);
      });
    }
  }

  handleAiUpdateOperation(response: any, planningId: string) {
    console.log('handleAiUpdateOperation:', response);

    // reset the actions to dispatch
    this.actionsToDispatch = [];

    let getActions = [];
    let updateActions = [];
    for (const actionGroup of response) {
      if (actionGroup.get && actionGroup.get.length > 0) {
        getActions = actionGroup.get as any[]; // action payload array for get actions, we expect only one get action
      }
      if (actionGroup.update && actionGroup.update.length > 0) {
        updateActions = actionGroup.update as any[]; // action payload array for update actions
      }
    }

    // get the data to update first
    if (getActions?.length) {
      getActions.forEach((getAction: any) => {
        // type is like '[Participant] Get'; parse entity name inside the []
        const entityName: string = getAction?.type?.match(/\[(.*?)\]/)?.[1];

        let actionType = `[${entityName.toUpperCase()}] Get${entityName}s`;

        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.getEntityItemsActionType) {
          actionType = entityConfig?.config?.getEntityItemsActionType;
        }

        this.store.dispatch({
          ...getAction,
          type: actionType,
          payload: {
            ...getAction.payload,
            filterId: planningId, // we pass the planning id to match to fetched data from the filter id
          },
        });
      });
    }

    // prepare the update
    if (updateActions?.length) {
      updateActions.forEach((action: any) => {
        // type is like '[Participant] Update'; parse entity name inside the []
        const entityName: string = action?.type?.match(/\[(.*?)\]/)?.[1];
        let actionType = `[${entityName.toUpperCase()}] Update${entityName}`;
        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.updateEntityActionType) {
          actionType = entityConfig?.config?.updateEntityActionType;
        }
        this.actionsToDispatch.push({
          ...action,
          type: actionType,
        });
      });
    }
  }

  handleAiDeleteOperation(response: any, planningId: string) {
    console.log('handleAiDeleteOperation:', response);

    // reset the actions to dispatch
    this.actionsToDispatch = [];

    let getActions = [];
    let deleteActions = [];
    for (const actionGroup of response) {
      if (actionGroup.get && actionGroup.get.length > 0) {
        getActions = actionGroup.get as any[]; // action payload array for get actions, we expect only one get action
      }
      if (actionGroup.delete && actionGroup.delete.length > 0) {
        deleteActions = actionGroup.delete as any[]; // action payload array for delete actions
      }
    }

    // get the data to update first
    if (getActions?.length) {
      getActions.forEach((getAction: any) => {
        // type is like '[Participant] Get'; parse entity name inside the []
        const entityName: string = getAction?.type?.match(/\[(.*?)\]/)?.[1];

        let actionType = `[${entityName.toUpperCase()}] Get${entityName}s`;

        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.getEntityItemsActionType) {
          actionType = entityConfig?.config?.getEntityItemsActionType;
        }

        this.store.dispatch({
          ...getAction,
          type: actionType,
          payload: {
            ...getAction.payload,
            filterId: planningId, // we pass the planning id to match to fetched data from the filter id
          },
        });
      });
    }

    // prepare the update
    if (deleteActions?.length) {
      deleteActions.forEach((action: any) => {
        // type is like '[Participant] Update'; parse entity name inside the []
        const entityName: string = action?.type?.match(/\[(.*?)\]/)?.[1];
        let actionType = `[${entityName.toUpperCase()}] Delete${entityName}`;
        const entityConfig = this.entityConfigsAsArray.find(
          (config: any) =>
            config?.name?.toLowerCase() === entityName.toLowerCase()
        );
        if (entityConfig?.config?.deleteEntityActionType) {
          actionType = entityConfig?.config?.deleteEntityActionType;
        }
        this.actionsToDispatch.push({
          ...action,
          type: actionType,
        });
      });
    }
  }

  onEntityItemSelected(item: EntityItemInterface) {
    console.log('Entity item selected:', item);
    this.activeEntityItem = item;
  }

  onEntitySelected(entity: EntityConfigInterface) {
    console.log('Entity selected:', entity);
    this.activeEntityConfig = entity;
  }

  onDemoQuestionAsked(question: string) {
    console.log('Demo question asked:', question);
    this.sendMessageToRapider(question);
  }

  onCreateProjectClicked(event: string) {
    if (this.projects && this.projects.length > 1) {
      this.router.navigate(['/projects/list']);
      console.log('Create project clicked:', event);
    } else {
      // if there is only one project, generate a new project
      this.projectCreateService.createEmptyProject();
    }
  }

  showSteps() {
    this.joyrideService.startTour(
      { steps: ['first', 'second', 'third', 'thirdOptional', 'fourthOptional', 'fifthOptional', 'sixthOptional', 'seventhOptional'], themeColor: '#2d2f34', waitingTime: 500, customTexts: { next: 'Next', prev: 'Prev', done: 'Done' }, showPrevButton: false }
    ).subscribe(
      (step) => {
      },
      (error) => {
      },
      () => {
      }
    );
  }

  showSteps2() {
    this.joyrideService.startTour(
      { steps: ['firstOptional', 'secondOptional', 'thirdOptional', 'fourth', 'fifth', 'sixth', 'fifthOptional', 'sixthOptional', 'seventhOptional',], themeColor: '#2d2f34', waitingTime: 500, customTexts: { next: 'Next', prev: 'Prev', done: 'Done' }, showPrevButton: false, startWith: 'fourth' }
    ).subscribe(
      (step) => {
      },
      (error) => {
      },
      () => {
      }
    );
  }

  onNextClick(step) {
    if (step === 'first') {
      this.browserStorageManagementService.setLocalStorageItem('tour', 'second');
    }
    if (step === 'second') {
      this.browserStorageManagementService.setLocalStorageItem('tour', 'third');
    }
  }

  onJoyrideDoneButtonClick() {
    this.browserStorageManagementService.setLocalStorageItem('tour', 'stop');
  }

  initWatcher() {
    if (this.browserStorageManagementService.getLocalStorageItem('tour') === 'done') {
      return;
    }

    this.startWatching();
  }

  startWatching() {
    interval(1000).pipe(
      map(() => this.browserStorageManagementService.getLocalStorageItem('tour')),
      takeWhile(val => val !== 'nineth', true)
    ).subscribe(val => {
      if (val === 'fourth') {
        this.onValueFour();
      }
      if (val === 'start') {
        this.showSteps();
      }
    });
  }

  onValueFour() {
    this.showSteps2();
  }

  onExploreClicked() {
    if (this.isDemoProject) {
      this.browserStorageManagementService.setLocalStorageItem('tour', 'start');
      this.router.navigate([FullPaths.AIAssistant]);
    }
  }

  onActionCardClicked(actionCard: any) {
    console.log('Action card clicked:', actionCard);
  }

  onToggleSplitterRightContainer() {
    // Clear any ongoing animation to prevent conflicts
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }

    const startSize = this.splitterRightContainerSize;
    // Determine the target: if it's open, target is 0; if closed, target is max size.
    const targetSize = this.splitterRightContainerSize > 0 ? 0 : this.maxRightSplitterSize;
    const sizeChange = targetSize - startSize;
    const startTime = Date.now();

    this.animationInterval = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const progress = Math.min(elapsedTime / this.animationDuration, 1);

      // Apply a simple "ease-out" function for a smoother effect
      const easedProgress = progress * (2 - progress);

      this.splitterRightContainerSize = startSize + sizeChange * easedProgress;

      // When the animation is complete, clear the interval
      if (progress === 1) {
        clearInterval(this.animationInterval);
        // Ensure the final size is exact to avoid small floating point errors
        this.splitterRightContainerSize = targetSize;
        this.collapseLeftSidebarIfChatAreaIsNotReadable();
      }
    }, 10); // Update every 10ms for a fluid 100fps animation
  }

  onCollapseSplitterRightContainer() {
    console.log('Splitter right container collapsed');
  }

  /* we will dispatch an action to collapse left side bar when the chat are is smaller than readableChatSize  */
  collapseLeftSidebarIfChatAreaIsNotReadable() {
    console.log('Checking if chat area is readable...');
    const chatAreaWidth = window.innerWidth - this.splitterRightContainerSize;
    console.log('Chat area width:', chatAreaWidth);
    this.adjustButtons();
    if (chatAreaWidth < this.readableChatSize) {
      this.store.dispatch(new CollapseLeftSidebar());
    }
  }

  onActionButtonClick(page: any) {
    if (this.splitterRightContainerSize === 0) {
      this.onToggleSplitterRightContainer();
    }
    // Navigate relative to the current activated route
    this.router.navigate(['page', page.id], { relativeTo: this.activatedRoute });
    console.log('Action button clicked:', page);
  }


  onEntitiesActionButtonClick() {
    if (this.splitterRightContainerSize === 0) {
      this.onToggleSplitterRightContainer();
    }
    // Navigate to the current route's path but with new query parameters.
    // The empty array [] signifies "stay on the current path".
    this.router.navigate(['assistant', this.getChannelIdWithoutQueryParams()], {
      relativeTo: this.activatedRoute,
      queryParams: { viewMode: 'list' }
    });
  }

  getAdditionalPages(): DropdownMenuItem[] {
    if (this.pages?.length && this.pages.length > 5) {
      return this.pages.slice(5).map((page: Page) => ({
        label: page.title || page.name,
        icon: { name: page.icon || 'fa-regular fa-window' },
        data: page
      }));
    }
    return [];
  }

  onAdditionalPagesDropdownItemClick(item: DropdownMenuItem) {
    const page = this.pages?.find((p: Page) => p.id === item.data?.id);
    if (page) {
      this.onActionButtonClick(page);
    }
  }

  openPageActionCardsClick() {
    this.pageActionCardsVisibility = true;
  }

  closePageActionCardsClick() {
    this.pageActionCardsVisibility = false;
  }

  onFilteredDataSources(filteredDataSources) {
    this.filteredDataSources = filteredDataSources;
    this.activeDataSources = this.activeDataSources.map(d => {
      if (filteredDataSources?.map(filtered => filtered.id)?.includes(d.id)) {
        return { ...d, selected: true }
      } else {
        return { ...d, selected: false }
      }
    })
  }
}
